import { render, staticRenderFns } from "./SkeletonItem.vue?vue&type=template&id=8a49398e"
import script from "./SkeletonItem.vue?vue&type=script&lang=js"
export * from "./SkeletonItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports